<template>
    <div class="assign-main">
        <header-add-contact @closeDialog="closeDialog" />
        <main-add-contact @closeDialog="closeDialog" />
    </div>
</template>
<script setup lang="ts">
import { ModalNames } from '~/types/modals';
import HeaderAddContact from './HeaderAssign.vue';
import MainAddContact from './MainAssign.vue';

const dialogRef = getDialogRef(ModalNames.ASSIGN_LICENSE);
const closeDialog = () => {
    dialogRef.value.close();
};
</script>
<style lang="scss" scoped>
.assign-main {
    @apply sm:max-w-xl sm:w-[440px] w-11/12 rounded-lg bg-white mx-auto h-auto overflow-y-auto;
}
</style>